import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType,
  UserPermission
} from '@globaleris/ui.library'
import { makeStyles, Typography, useTheme } from '@material-ui/core'
import { FindInPageOutlined } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SettlementsObjectionsTableModel } from '../../../../api/Argentia/endpoints/settlements/model/settlements'
import { EnumCriticidad } from '../../../../api/oData/enums/enumCriticidad'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'
import { enumToSelectOptionArray } from '../../../../helpers'
import { getCustomerDomain } from '../../../../redux'
import { styles } from '../../settlements.styles'

interface SettlementObjectionsCardProps {
  data: SettlementsObjectionsTableModel[]
  isLoading?: boolean
  show?: boolean
  onViewListClick?: (selectedRow: SettlementsObjectionsTableModel) => void
}

export const SettlementObjectionsCard: React.FC<SettlementObjectionsCardProps> = ({
  data,
  isLoading,
  show = true,
  onViewListClick = () => {}
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'settlements'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const noData = data && data.length === 0

  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // setStates
  //const {errorProps}= useHttpError()
  //const { dataTableFilter, dataTableSearch } = usePageState()

  const settlementsObjectionsDataTableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 0,
    filterType: FilterType.ADVANCED,
    customInsertEditModal: true,

    pagination: true,
    // rowsPerPage: 10,
    // rowsPerPageOptions: [10,20,100],

    analytics: {
      customer: getCustomerDomain(),
      view: t('settlements:components.settlementObjectionsCard.dataTable.analytics')
    },
    // onRowInsert: handleInsertAction,
    rowCustomActions: [
      {
        icon: <FindInPageOutlined fontSize="small" />,
        tooltip: t('settlements:components.settlementObjectionsCard.dataTable.tooltips.viewList'),
        onClick: onViewListClick,
        userPermission: UserPermission.EDIT
      }
    ]
    // onFilterChange: (filter: ColumnFilter[]) => {
    //   storeDataTableFilterForCurrentPage(filter)
    // },
    // onSearchChange: (search: string) => {
    //   storeDataTableSearchForCurrentPage(search)
    // }
  }

  const settlementsObjectionsDataTableColumns: DataTableColumn[] = [
    {
      name: 'objCode',
      label: t('settlements:components.settlementObjectionsCard.dataTable.columns.objCode'),
      type: DataType.TEXT,
      columnWidth: 10
    },
    {
      name: 'objDescription',
      label: t('settlements:components.settlementObjectionsCard.dataTable.columns.objDescription'),
      type: DataType.TEXT,
      columnWidth: 150
    },
    {
      name: 'objCriticality',
      label: t('settlements:components.settlementObjectionsCard.dataTable.columns.objCriticality'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumCriticidad, 'enums:EnumCriticidad'),
      columnWidth: 400
    },
    {
      name: 'objCount',
      label: t('settlements:components.settlementObjectionsCard.dataTable.columns.objCount'),
      type: DataType.TEXT,
      columnWidth: 10
    }
  ]

  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  // #region Footer Actions Starts
  // #endregion Footer Actions Ends

  return show ? (
    <StandardCard
      // title={t('settlements:components.settlementObjectionsCard.title')}
      // titleVariant={'secondary'}
      noTransition={false}
      unmountOnExit={true}
      isLoading={isLoading}
      // showEmptyContent={noData}
      // emptyCaption={t('settlements:components.settlementObjectionsCard.emptyCaption')}
      className={classes.card}
      raised={false}
    >
      <DataTable
        title={
          <Typography variant="h6">
            {t('settlements:components.settlementObjectionsCard.title')}
          </Typography>
        }
        data={data}
        columns={settlementsObjectionsDataTableColumns}
        options={settlementsObjectionsDataTableOptions}
      />
    </StandardCard>
  ) : (
    <></>
  )
}
